import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import './App.css';
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Services from '../src/pages/services/Services'
import Home from '../src/pages/home/Home'
import AboutUs from '../src/pages/aboutUs/AboutUs'
import ContactUs from '../src/pages/contactUs/ContactUs'
import Hero from "./components/hero/Hero";


function App() {
  return (
    <div className="App">
     <Router>
       
        <Hero/>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/services" element={<Services/>} />
          <Route path="/about" element={<AboutUs/>} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
